<!--
 * @Descripttion:
 * @version:
 * @Author: lubaicen
 * @Date: 2020-09-15 19:57:39
 * @LastEditors: lubaicen
 * @LastEditTime: 2020-10-19 16:25:30
-->
<template>
  <ux-form
    ref="form"
    :data="formData"
    :colon="true"
    :rules="rules"
    width="440px"
    label-width="56px"
    data-automation="groupDeital"
    @close="close"
    @confirm="confirm"
  >
    <ux-form-item :label="$t('HT.apiList.group')" required prop="name">
      <ux-input
        v-model="formData.name"
        :maxlength="50"
        :placeholder="$t('HT.rules.groupDetail.name1')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.apiStepOne.remark')" start prop="remark">
      <ux-input
        v-model="formData.remark"
        type="textarea"
        :autosize="{ minRows: 5, maxRows: 5 }"
        resize="none"
        :maxlength="180"
        show-word-limit
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      formData: {
        id: this.data.id, //分组id
        name: this.data.name, // 分组名称
        remark: this.data.remark //备注
      },
      rules: this.$rul.groupDetail()
    };
  },
  methods: {
    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
      this.$emit('close');
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.formData);
        }
      });
    }
  }
};
</script>
